import React from 'react';
import PropTypes from 'prop-types';
import { clsHeaderIcon } from '../helpers/TableHelpers';
import { isAdminDashboard } from 'utils/authScopes';

export default class AccountsHeader extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    onSortChange: PropTypes.func.isRequired,
  }

  onSortChange = (e) => {
    const sort = e.target.dataset.sort;
    const order = this.props.meta.order || 'asc';
    const newOrder = order === 'desc' ? 'asc' : 'desc';
    this.props.onSortChange(sort, newOrder);
  }

  render() {
    const { auth, meta } = this.props;
    return (
      <thead>
        <tr>
          <th data-sort='id' onClick={this.onSortChange}>
            <span data-sort='id' className='o-table-header--sort'>
              Id<i data-sort='id' className={clsHeaderIcon('id', meta)}></i>
            </span>
          </th>
          <th data-sort='first_name' onClick={this.onSortChange}>
            <span data-sort='first_name' className='o-table-header--sort'>
              First Name<i data-sort='first_name' className={clsHeaderIcon('first_name', meta)}></i>
            </span>
          </th>
          <th data-sort='last_name' onClick={this.onSortChange}>
            <span data-sort='last_name' className='o-table-header--sort'>
              Last Name<i data-sort='last_name' className={clsHeaderIcon('last_name', meta)}></i>
            </span>
          </th>
          <th data-sort='email' onClick={this.onSortChange}>
            <span data-sort='email' className='o-table-header--sort'>
              Email<i data-sort='email' className={clsHeaderIcon('email', meta)}></i>
            </span>
          </th>
          <th data-sort='created_at' onClick={this.onSortChange}>
            <span data-sort='created_at' className='o-table-header--sort'>
              Created At<i data-sort='created_at' className={clsHeaderIcon('created_at', meta)}></i>
            </span>
          </th>
          { isAdminDashboard(auth) && <th>Partner</th> }
          <th>Children</th>
          <th data-sort='current_sign_in_at' onClick={this.onSortChange}>
            <span data-sort='current_sign_in_at' className='o-table-header--sort'>
              Last App Touch<i data-sort='current_sign_in_at' className={clsHeaderIcon('current_sign_in_at', meta)}></i>
            </span>
          </th>
          <th>Last Activity</th>
          <th data-sort='archived' onClick={this.onSortChange}>
            <span data-sort='archived' className='o-table-header--sort'>
              Status<i data-sort='archived' className={clsHeaderIcon('archived', meta)}></i>
            </span>
          </th>
          <th>Total Plays</th>
          <th>Total Photos</th>
          {/* <th>Actions</th> */}
        </tr>
      </thead>
    );
  }
}
